"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const NavigationWrapperWeb_1 = __importDefault(require("../common/NavigationWrapperWeb"));
const react_1 = require("react");
const AccountListWeb_1 = __importDefault(require("./AccountListWeb"));
const ChangeLanguageWeb_1 = __importDefault(require("./ChangeLanguageWeb"));
const userHandlers_1 = require("../../handlers/userHandlers");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../store/redux/selectors");
const native_1 = require("@react-navigation/native");
const AccountWeb = () => {
    (0, native_1.useFocusEffect)((0, react_1.useCallback)(() => {
        (0, userHandlers_1.getUserDetailsHandler)();
    }, []));
    const user = (0, react_redux_1.useSelector)(selectors_1.getUser);
    const [screen, setScreen] = (0, react_1.useState)('account-list');
    return ((0, jsx_runtime_1.jsxs)(NavigationWrapperWeb_1.default, { children: [screen === 'account-list' && (0, jsx_runtime_1.jsx)(AccountListWeb_1.default, { setScreen: setScreen, user: user }), screen === 'translate' && (0, jsx_runtime_1.jsx)(ChangeLanguageWeb_1.default, { setScreen: setScreen, user: user })] }));
};
exports.default = AccountWeb;
